(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('ConfigService', [
            '$location',
            'UtilitiesService',
            ConfigService
        ]);

    function ConfigService($location, utilitiesService) {
        // returns models grouped by make in the following format
        // [{name:make1, data:[...]}, {name:make2, data:[...]}]
        function customModelBox(cvs, mergedMakes, conditionManager) {
            if (!cvs['md']) return [];
            if (!mergedMakes) return [];
            // the search result may return models for more makes than we need, so we first choose the selected model ids only and then map them to names
            // On the other hand, the search result might not return the models for all makes that we need. In that case, the model id would be maped to 'false'
            // and later ignored
            var mkMap = {};
            var makes = conditionManager.getConditionValue('mk');
            makes.forEach(function (x) {
                mkMap[x] = false
            });
            mergedMakes.forEach(function (x) {
                if (mkMap[x.id] == false) mkMap[x.id] = x.name
            });

            var mkMdMap = {};

            utilitiesService.mergeEnums(cvs['md']).forEach(function (row) {
                if (mkMap[row.mk]) {
                    mkMdMap[row.mk] = mkMdMap[row.mk] || [];
                    mkMdMap[row.mk].push(row);
                }
            });

            if (!conditionManager.checkboxGroupMessage.mk) return [];
            var mdBox = [];
            //loop mergedMakes values then use mergedMakes id to check if exist in mkMap
            //if exixt push to mdBox will be transformed to modelbox value
            mergedMakes.forEach(function (x) {
                var mk = x.id;
                var mkName = mkMap[mk];
                if (mkName)

                    mdBox.push({"name": mkName, "data": mkMdMap[mk]})
            });

            //check modelbox if has value
            //will hide defaultModelEmpty if condition satisfied
            if (mdBox.length > 0 && mdBox[0].data.length > 0) {
                angular.element("#defaultModelEmpty").css("display", "none");
            }

            return mdBox;
        }

        // Applicable values configurators. Each configurator could be applied to multiple pages. See addApplicableValuesConfig function
        var applicableValuesConfigurationActions = {
            "mk": function (searchCriteriaConfig) {
                return {
                    "requestor": searchCriteriaConfig.facetEnumRequestorFactory("mk"),
                    "transformer": function (conditionValues, conditionManager, transformedValues) {
                        return utilitiesService.mergeEnums(conditionValues['mk'])
                    }
                }
            },
            "smk": function (searchCriteriaConfig) {
                return {
                    "requestor": searchCriteriaConfig.facetEnumRequestorFactory("smk"),
                    "transformer": function (conditionValues, conditionManager, transformedValues) {
                        return utilitiesService.mergeEnums(conditionValues['smk'])
                    }
                }
            },
            "div": function (searchCriteriaConfig) {
                return {
                    "requestor": searchCriteriaConfig.facetEnumRequestorFactory("div"),
                    "transformer": function (conditionValues, conditionManager, transformedValues) {
                        return utilitiesService.mergeEnums(conditionValues['div']).sort(function (a, b) {
                            return a.name.localeCompare(b.name)
                        })
                    }
                }
            },
            "pat": function (searchCriteriaConfig) {
                return {
                    "transformer": function (conditionValues, conditionManager, transformedValues) {
                        return utilitiesService.appCondValTransformers.nameTransformer(conditionValues['pat'].data, {
                            "1": "ADESA Locations",
                            "2": "Certified Auction Partners",
                            "OTHER": "Offsite Vehicles"
                        })
                    }
                }
            },
            "md": function (searchCriteriaConfig) {
                return {
                    "requestor": function (searchContext, conditionManager) {
                        var f = searchCriteriaConfig.facetEnumRequestorFactory("md", "mk");
                        if (conditionManager.checkboxGroupMessage.mk) {
                            searchContext.getCondition('mk').setValue(conditionManager.checkboxGroupMessage.mk.refined());
                            f(searchContext);
                        }
                    },
                    "transformer": function (conditionValues, conditionManager, transformedValues) {
                        function deferredTransformer() {
                            return customModelBox(conditionValues, transformedValues['mk'], conditionManager);
                        }

                        if (transformedValues['mk']) return deferredTransformer();
                        else return deferredTransformer;
                    }
                }
            },
            "pao": function (searchCriteriaConfig) {
                return {
                    "requestor": function (searchContext, conditionManager) {
                        if (conditionManager.checkboxGroupMessage.pat) {
                            searchContext.getCondition('pat').setValue(conditionManager.checkboxGroupMessage.pat.refined());
                            searchContext.getCondition("pao").calculateCounts(searchCriteriaConfig["defaultConditionsArr"].concat("pat"));
                        }
                    }
                }
            },
            "auch": function (searchCriteriaConfig) {
                return {
                    "requestor": function (searchContext, conditionManager) {
                        searchContext.getCondition("auch").requestEnumeration();
                    },
                    "transformer": function (conditionValues, conditionManager, transformedValues) {
                        return [{"id": "rl", "name": "Run List", "count": ""}, {"id": "lb", "name": "LiveBlock", "count": ""}];
                    }
                }
            }
        };

        // Configurations for conditions that are displayed depending on the value of some other conditions. For example the model selection display
        // changes when the make selection changes. See the usage in SearchCriteriaController.js
        var conditionalSelectors = {
            "md": {
                // a condition that is conditionally displayed
                "cond": "md",
                // if the value returned by the following function changes then this condition selection must be refreshed
                "dependencyCondition": function (conditionManager) {
                    if (!conditionManager.checkboxGroupMessage.mk) return [];
                    return conditionManager.checkboxGroupMessage.mk.refined();
                },
                // A set reconstructed from the transformed values.
                "map": function (transformedValues) {
                    var set = transformedValues.reduce(function (set, makeGroup) {
                        makeGroup.data.forEach(function (model) {
                            set[model.id] = true
                        });
                        return set;
                    }, {});
                    return set;
                }
            },
            "pao": {
                "cond": "pao",
                "dependencyCondition": function (conditionManager) {
                    if (!conditionManager.checkboxGroupMessage.pat) return [];
                    return conditionManager.checkboxGroupMessage.pat.refined();
                },
                "map": function (transformedValues) {
                    var set = transformedValues.reduce(function (set, row) {
                        set[row.id] = true;
                        return set;
                    }, {});
                    return set;
                }
            }
        };


        function Config(config) {
            var that = this;
            // the conditions represented as multiple choice checkboxes
            this.checkboxConditions = config.checkboxConditions || [];
            // a convenience configuration for 'other options' checkbox group
            this.otherOptions = config.otherOptions || [];
            // these conditions are always applied to the count calculations (if set)
            this.defaultConditionsArr = config.defaultConditionsArr;
            this.conditionalSelectors = config.conditionalSelectors || [];

            // just a convenience method that is requesting both counts and enumerations from the search engine
            this.facetEnumRequestorFactory = function (cond, additionalCountConditions) {
                return function (searchContext, conditionManager) {
                    var condition = searchContext.getCondition(cond);
                    var applConds = that.defaultConditionsArr ? that.defaultConditionsArr.concat(additionalCountConditions) : additionalCountConditions;
                    condition.calculateCounts(applConds);
                    condition.requestEnumeration();
                }
            }

            var appValuesConfig = {};
            // executes selected applicableValuesConfigurationActions
            this.addApplicableValuesConfig = function (conditions) {
                conditions.forEach(function (key) {
                    appValuesConfig[key] = applicableValuesConfigurationActions[key](that);
                });
            };
            this.getApplicableValuesConfig = function (cond) {
                var config = appValuesConfig[cond] || {};
                var apiCond = OpenlaneSearchEngine.supportedConditions[cond];
                // default is to request and transform to facet
                // falls back to enumeration if a facet is not supported
                // the enumeration usually supports more values than facet. If you want to display the enumeration
                // when a facet is supported then explicitly define it in 'applicableValuesConfigurationActions'
                // and add using 'addApplicableValuesConfig'
                config.requestor = config.requestor || function (searchContext, conditionManager) {
                        if (apiCond) {
                            if (apiCond.stats) searchContext.getCondition(cond).calculateCounts(that.defaultConditionsArr);
                            else if (apiCond.enumeration) searchContext.getCondition(cond).requestEnumeration();
                        }

                    };
                config.transformer = config.transformer || function (conditionValues, conditionManager, criteria) {
                        if (apiCond) {
                            if (apiCond.stats) return conditionValues[cond].data;
                            else if (apiCond.enumeration) return conditionValues[cond].enum;
                            else return [];
                        }
                    };
                return config;
            }
        }

        // ========= SEARCH CRITERIA PAGE =============== //
        var searchCriteriaConfig = new Config({
            "checkboxConditions": ["mk", "div", "md", "pat", "pao", "auch", "lbln"],
            "otherOptions": [{"cond": "xxlt", "desc": "Leather Upholstery"},
                {"cond": "nv", "desc": "Navigation"},
                {"cond": "rse", "desc": "Rear Seat Entertainment"},
                {"cond": "sn", "desc": "Sunroof"},
                {"cond": "fr", "desc": "First Run"},
                {"cond": "tpi", "desc": "Condition Report"},
                {"cond": "nd", "desc": "No Frame Damage"},
                {"cond": "fd", "desc": "Has Frame Damage"},
                {"cond": "nr", "desc": "Exclude Reviewed"},
                {"cond": "et", "desc": "Exclude In Transit"},
                {"cond": "oer", "desc": "Open = Reserve"},
                {"cond": "pr", "desc": "Price Reduce"},
                {"cond": "pic", "desc": "Has Pictures"},
                {"cond": "bd", "desc": "Has Bids"},
                {"cond": "nh", "desc": "Exclude Hidden Vehicles"},
                {"cond": "lr", "desc": "Last Run"},
                {"cond": "noaced", "desc": "Exclude AutoCheck Ex..."}
            ],
            "defaultConditionsArr": ["ast", "auch", "pao"],
            "conditionalSelectors": [conditionalSelectors.md, conditionalSelectors.pao]
        });
        searchCriteriaConfig.addApplicableValuesConfig(["mk", "md", "div", "pat", "pao", "auch"]);


        // ========= SPECIALTY SEARCH CRITERIA PAGE =============== //
        var searchCriteriaSpConfig = new Config({
            "checkboxConditions": ["smk", "div", "pat", "pao", "auch", "ast"],
            "otherOptions": [{"cond": "fr", "desc": "First Run"},
                {"cond": "tpi", "desc": "Condition Report"},
                {"cond": "nr", "desc": "Exclude Reviewed"},
                {"cond": "et", "desc": "Exclude In Transit"},
                {"cond": "oer", "desc": "Open = Reserve"},
                {"cond": "pr", "desc": "Price Reduced"},
                {"cond": "pic", "desc": "Has Pictures"},
                {"cond": "bd", "desc": "Has Bids"},
                {"cond": "nh", "desc": "Exclude Hidden Vehicles"},
                {"cond": "lr", "desc": "Last Run"}
            ],
            "defaultConditionsArr": ["east", "auch"],
            "conditionalSelectors": [conditionalSelectors.pao]
        });
        searchCriteriaSpConfig.addApplicableValuesConfig(["smk", "div", "pat", "pao", "auch"]);


        // ========= SEARCH RESULT PAGE =============== //
        var searchResultConfig = new Config({
            "checkboxConditions": ["mk", "md", "div", "auch", "pat", "pao", "grd", "sl", "slt", "rlad", "rlet", "cle", "tr", "lbln", 'trm'],
            "otherOptions": searchCriteriaConfig.otherOptions
        });
        searchResultConfig.addApplicableValuesConfig(["auch", "pat"]);
        // Sortable table headers

        searchResultConfig.sortableHeaders =
            [
              {
                "name": 'searchThumbnail',
                "sort": [
                  {"name": "rlRunNo", "dir": "a" },
                  {"name": "yr",      "dir": "d" },
                  {"name": "mk",      "dir": "a" },
                  {"name": "md",      "dir": "a" }
                ]
              },
              {
                "name": 'searchRun',
                "sort": [{"name": "rlRunNo", "dir": "a"},
                         {"name": "yr", "dir": "d"},
                         {"name": "mk", "dir": "a"},
                         {"name": "md", "dir": "a"}
                ]
               },
               {
                    "name": "searchLane",
                    "sort": [{"name": "lbln", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }]
                },
                {
                    "name": "yearTitle",
                    "sort": [{"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {"name": "md", "dir": "a"}, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "makeTitle",
                    "sort": [{"name": "mk", "dir": "a"}, {"name": "md", "dir": "a"}, {"name": "yr", "dir": "d"}, {
                        "name": "sr",
                        "dir": "a"
                    }, {"name": "rlClr", "dir": "a"}, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "modelTitle",
                    "sort": [{"name": "md", "dir": "a"}, {"name": "sr", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "searchBodystyle",
                    "sort": [{"name": "rlBody", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "searchD",
                    "sort": [{"name": "rlDr", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "searchEngine",
                    "sort": [{"name": "rlEng", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "od", "dir": "a"}]
                },
                {"name": "searchRunlistOdometer", "sort": [{"name": "od", "dir": "a"}, {"name": "yr", "dir": "d"}]},
                {
                    "name": "searchRunlistColour",
                    "sort": [{"name": "rlClr", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "od", "dir": "a"}]
                },
                {"name": "searchRunlistVin", "sort": [{"name": "vin", "dir": "a"}]},
                {
                    "name": "searchRunlistDate",
                    "sort": [{"name": "rlSEDate", "dir": "a"}, {"name": "divpa", "dir": "a"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "yr", "dir": "d"}, {"name": "sr", "dir": "a"}]
                },
                {
                    "name": "searchRunlistConsignor",
                    "sort": [{"name": "slr", "dir": "a"}, {"name": "mk", "dir": "a"}, {"name": "md", "dir": "a"}, {
                        "name": "yr",
                        "dir": "d"
                    }, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "locationTitle",
                    "sort": [{"name": "divpa", "dir": "a"}, {"name": "mk", "dir": "a"}, {"name": "md", "dir": "a"}, {
                        "name": "yr",
                        "dir": "d"
                    }, {"name": "sr", "dir": "a"}, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "searchGrade",
                    "sort": [{"name": "grd", "dir": "d"}, {"name": "rlRunNo", "dir": "a"}, {"name": "yr", "dir": "d"}, {
                        "name": "mk",
                        "dir": "a"
                    }, {"name": "md", "dir": "a"}]
                },
                {
                    "name": "searchCr",
                    "sort": [{"name": "tpi", "dir": "d"}, {"name": "yr", "dir": "a"}, {"name": "mk", "dir": "d"}, {
                        "name": "md",
                        "dir": "a"
                    }]
                }
            ];
        // Sort definitions on the drop down menu. Are automatically in sync with the sortable headers if the sort combination is the same.
        searchResultConfig.sortableCriteria =
            [
                {
                    "name": "search.run.ascending",
                    "sort": [{"name": "rlRunNo", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }]
                },
                {
                    "name": "search.run.descending",
                    "sort": [{"name": "rlRunNo", "dir": "d"}, {"name": "yr", "dir": "a"}, {"name": "mk", "dir": "d"}, {
                        "name": "md",
                        "dir": "d"
                    }]
                },
                {
                    "name": "search.lane.ascending",
                    "sort": [{"name": "lbln", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }]
                },
                {
                    "name": "search.lane.descending",
                    "sort": [{"name": "lbln", "dir": "d"}, {"name": "yr", "dir": "a"}, {"name": "mk", "dir": "d"}, {
                        "name": "md",
                        "dir": "d"
                    }]
                },
                {
                    "name": "search.year.ascending",
                    "sort": [{"name": "yr", "dir": "a"}, {"name": "mk", "dir": "d"}, {"name": "md", "dir": "d"}, {"name": "od", "dir": "d"}]
                },
                {
                    "name": "search.year.descending",
                    "sort": [{"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {"name": "md", "dir": "a"}, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "search.make.ascending",
                    "sort": [{"name": "mk", "dir": "a"}, {"name": "md", "dir": "a"}, {"name": "yr", "dir": "d"}, {
                        "name": "sr",
                        "dir": "a"
                    }, {"name": "rlClr", "dir": "a"}, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "search.make.descending",
                    "sort": [{"name": "mk", "dir": "d"}, {"name": "md", "dir": "d"}, {"name": "yr", "dir": "a"}, {
                        "name": "sr",
                        "dir": "d"
                    }, {"name": "rlClr", "dir": "d"}, {"name": "od", "dir": "d"}]
                },
                {
                    "name": "search.model.ascending",
                    "sort": [{"name": "md", "dir": "a"}, {"name": "sr", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "search.model.descending",
                    "sort": [{"name": "md", "dir": "d"}, {"name": "sr", "dir": "d"}, {"name": "yr", "dir": "a"}, {"name": "od", "dir": "d"}]
                },
                {
                    "name": "search.body.ascending",
                    "sort": [{"name": "rlBody", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "search.body.descending",
                    "sort": [{"name": "rlBody", "dir": "d"}, {"name": "yr", "dir": "a"}, {"name": "mk", "dir": "d"}, {
                        "name": "md",
                        "dir": "d"
                    }, {"name": "od", "dir": "d"}]
                },
                {
                    "name": "search.d.ascending",
                    "sort": [{"name": "rlDr", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "search.d.descending",
                    "sort": [{"name": "rlDr", "dir": "d"}, {"name": "yr", "dir": "a"}, {"name": "mk", "dir": "d"}, {
                        "name": "md",
                        "dir": "d"
                    }, {"name": "od", "dir": "d"}]
                },
                {
                    "name": "search.engine.ascending",
                    "sort": [{"name": "rlEng", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "search.engine.descending",
                    "sort": [{"name": "rlEng", "dir": "d"}, {"name": "yr", "dir": "a"}, {"name": "mk", "dir": "d"}, {
                        "name": "md",
                        "dir": "d"
                    }, {"name": "od", "dir": "d"}]
                },
                {"name": "search.odometer.ascending", "sort": [{"name": "od", "dir": "a"}, {"name": "yr", "dir": "d"}]},
                {"name": "search.odometer.descending", "sort": [{"name": "od", "dir": "d"}, {"name": "yr", "dir": "a"}]},
                {
                    "name": "search.color.ascending",
                    "sort": [{"name": "rlClr", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "search.color.descending",
                    "sort": [{"name": "rlClr", "dir": "d"}, {"name": "yr", "dir": "a"}, {"name": "mk", "dir": "d"}, {
                        "name": "md",
                        "dir": "d"
                    }, {"name": "od", "dir": "d"}]
                },
                {"name": "search.vin.ascending", "sort": [{"name": "vin", "dir": "a"}]},
                {"name": "search.vin.descending", "sort": [{"name": "vin", "dir": "d"}]},
                {
                    "name": "search.date.ascending",
                    "sort": [{"name": "rlSEDate", "dir": "a"}, {"name": "divpa", "dir": "a"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "a"
                    }, {"name": "yr", "dir": "d"}, {"name": "sr", "dir": "a"}]
                },
                {
                    "name": "search.date.descending",
                    "sort": [{"name": "rlSEDate", "dir": "d"}, {"name": "divpa", "dir": "d"}, {"name": "mk", "dir": "d"}, {
                        "name": "md",
                        "dir": "d"
                    }, {"name": "yr", "dir": "a"}, {"name": "sr", "dir": "d"}]
                },
                {
                    "name": "search.consignor.ascending",
                    "sort": [{"name": "slr", "dir": "a"}, {"name": "mk", "dir": "a"}, {"name": "md", "dir": "a"}, {
                        "name": "yr",
                        "dir": "d"
                    }, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "search.consignor.descending",
                    "sort": [{"name": "slr", "dir": "d"}, {"name": "mk", "dir": "d"}, {"name": "md", "dir": "d"}, {
                        "name": "yr",
                        "dir": "a"
                    }, {"name": "od", "dir": "d"}]
                },
                {
                    "name": "search.location.ascending",
                    "sort": [{"name": "divpa", "dir": "a"}, {"name": "mk", "dir": "a"}, {"name": "md", "dir": "a"}, {
                        "name": "yr",
                        "dir": "d"
                    }, {"name": "sr", "dir": "a"}, {"name": "od", "dir": "a"}]
                },
                {
                    "name": "search.location.descending",
                    "sort": [{"name": "divpa", "dir": "d"}, {"name": "mk", "dir": "d"}, {"name": "md", "dir": "d"}, {
                        "name": "yr",
                        "dir": "a"
                    }, {"name": "sr", "dir": "d"}, {"name": "od", "dir": "d"}]
                },
                {
                    "name": "search.grade.ascending",
                    "sort": [{"name": "grd", "dir": "a"}, {"name": "rlRunNo", "dir": "d"}, {"name": "yr", "dir": "a"}, {
                        "name": "mk",
                        "dir": "d"
                    }, {"name": "md", "dir": "d"}]
                },
                {
                    "name": "search.grade.descending",
                    "sort": [{"name": "grd", "dir": "d"}, {"name": "rlRunNo", "dir": "a"}, {"name": "yr", "dir": "d"}, {
                        "name": "mk",
                        "dir": "a"
                    }, {"name": "md", "dir": "a"}]
                },
                {
                    "name": "search.cr.ascending",
                    "sort": [{"name": "tpi", "dir": "a"}, {"name": "yr", "dir": "d"}, {"name": "mk", "dir": "a"}, {
                        "name": "md",
                        "dir": "d"
                    }]
                },
                {
                    "name": "search.cr.descending",
                    "sort": [{"name": "tpi", "dir": "d"}, {"name": "yr", "dir": "a"}, {"name": "mk", "dir": "d"}, {
                        "name": "md",
                        "dir": "a"
                    }]
                }
            ];


        // ========= SPECIALTY SEARCH RESULT PAGE =============== //
        var searchResultSpConfig = new Config({
            "checkboxConditions": ["smk", "ast", "div", "auch", "pao", "grd", "sl", "slt", "rlad", "rlet", "cle", "cli", "tr"],
            "otherOptions": searchCriteriaSpConfig.otherOptions
        });
        searchResultSpConfig.addApplicableValuesConfig(["auch"]);
        searchResultSpConfig.sortableHeaders = searchResultConfig.sortableHeaders;
        searchResultSpConfig.sortableCriteria =
            [{
                "name": "Time Left | Proximity",
                "sort": [{"name": "auchPr", "dir": "a"}, {"name": "et", "dir": "a"}, {
                    "name": "d",
                    "dir": "a"
                }, {"name": "vid", "dir": "a"}]
            },
                {"name": "Run #", "sort": [{"name": "rlRunNo", "dir": "a"}, {"name": "vid", "dir": "a"}]},
                {
                    "name": "Lane | Run #",
                    "sort": [{"name": "lbln", "dir": "a"}, {"name": "rlRunNo", "dir": "a"}, {
                        "name": "vid",
                        "dir": "a"
                    }]
                },
                {"name": "Auction Date", "sort": [{"name": "rlSEDate", "dir": "a"}, {"name": "vid", "dir": "a"}]},
                {
                    "name": "Year | Odometer | Price",
                    "sort": [{"name": "yr", "dir": "d"}, {"name": "od", "dir": "a"}, {
                        "name": "mp",
                        "dir": "a"
                    }, {"name": "vid", "dir": "a"}]
                },
                {
                    "name": "Price | Year | Odometer",
                    "sort": [{"name": "mp", "dir": "a"}, {"name": "yr", "dir": "d"}, {
                        "name": "od",
                        "dir": "a"
                    }, {"name": "vid", "dir": "a"}]
                },
                {
                    "name": "Odometer | Price | Year",
                    "sort": [{"name": "od", "dir": "a"}, {"name": "mp", "dir": "a"}, {
                        "name": "yr",
                        "dir": "d"
                    }, {"name": "vid", "dir": "a"}]
                },
                {"name": "Price - High to Low", "sort": [{"name": "mp", "dir": "d"}, {"name": "vid", "dir": "d"}]},
                {"name": "Price - Low to High", "sort": [{"name": "mp", "dir": "a"}, {"name": "vid", "dir": "a"}]},
                {"name": "Distance - Nearest", "sort": [{"name": "d", "dir": "a"}, {"name": "vid", "dir": "a"}]},
                {"name": "Year - New to Old", "sort": [{"name": "yr", "dir": "d"}, {"name": "vid", "dir": "a"}]},
                {"name": "Year - Old to New", "sort": [{"name": "yr", "dir": "a"}, {"name": "vid", "dir": "d"}]},
                {
                    "name": "Odometer - Low to High",
                    "sort": [{"name": "od", "dir": "a"}, {"name": "vid", "dir": "a"}]
                },
                {
                    "name": "Odometer - High to Low",
                    "sort": [{"name": "od", "dir": "d"}, {"name": "vid", "dir": "d"}]
                },
                {"name": "Grade - Low to High", "sort": [{"name": "grd", "dir": "a"}, {"name": "vid", "dir": "a"}]},
                {"name": "Grade - High to Low", "sort": [{"name": "grd", "dir": "d"}, {"name": "vid", "dir": "d"}]},
                {"name": "Make - Ascending", "sort": [{"name": "mk", "dir": "a"}, {"name": "vid", "dir": "a"}]},
                {"name": "Make - Descending", "sort": [{"name": "mk", "dir": "d"}, {"name": "vid", "dir": "d"}]}
            ];

        var scConfig = {'/searchCriteria': searchCriteriaConfig, '/searchCriteriaSp': searchCriteriaSpConfig};
        var srConfig = {'/searchResult': searchResultConfig, '/searchResultSp': searchResultSpConfig};
        return {
            "scConfig": function () {
                return searchCriteriaConfig;
            },
            "srConfig": function () {
                return searchResultConfig;
            }
        };
    }

})();



// WEBPACK FOOTER //
// ./app/search/components/service/ConfigService.js